import bugsnag from '@bugsnag/js'
import { getEnv } from 'aria-viewer/utils/environment'
import Mousetrap from 'mousetrap'

const { gpu, grade, ram, resolution, version } = window.YV_AV.device

const bugsnagClient = bugsnag({
    apiKey: getEnv('REACT_APP_BUGSNAG_API_KEY'),
    releaseStage: getEnv('NODE_ENV'),
    notifyReleaseStages: ['production', 'staging'],
    appVersion: window.YV_AV.appVersion,
    metaData: {
        gpu,
        grade,
        ram,
        resolution,
        version,
    },
})

const slowPageLoadTracking = () => {
    // Set slow request threshold to 10 seconds (10,000ms)
    const SLOW_REQUEST_THRESHOLD_MS = 10000

    const trackPageLoadTime = () => {
        // Skip browsers that don't support navigation timing
        if (!window.performance || !window.performance.timing) {
            return
        }

        const requestStart = window.performance.timing.requestStart
        const requestEnd = window.performance.timing.domComplete
        const loadTime = requestEnd - requestStart

        // If the page isn't done loading, try again later
        if (!requestEnd) {
            return setTimeout(trackPageLoadTime, 1000)
        }

        // Notify Bugsnag if page load time has exceeded the threshhold
        if (loadTime > SLOW_REQUEST_THRESHOLD_MS) {
            bugsnagClient.notify(new Error(`Slow page load. Load time exceeded ${SLOW_REQUEST_THRESHOLD_MS}ms`), {
                request: { 'page load time': loadTime },
            })
        }
    }

    // Don't start checking until the page is likely to have loaded
    setTimeout(trackPageLoadTime, 3000)
}

const monitorPageRefreshes = () => {
    // Set up refresh tracking
    Mousetrap.bind(['command+r', 'ctrl+r', 'f5'], () => {
        bugsnagClient.notify(new Error('Page refreshed'))
    })
}

const rageClickDetecion = () => {
    // Set up rage click detection
    const CLICK_TIME_THRESHOLD = 500
    const CLICK_COUNT_TRESHOLD = 5

    const now = () => new Date().getTime()

    let last = now()
    let count = 0

    // Only listen for events that bubble up to the window - events that are
    // cancelled before hitting window are likely to be handled by the app.
    window.addEventListener('mouseup', e => {
        const current = now()

        if (current - last < CLICK_TIME_THRESHOLD) {
            count += 1
        }

        if (count > CLICK_COUNT_TRESHOLD) {
            const { className, id, nodeName } = e.target

            bugsnagClient.notify(new Error('Rage click'), {
                'last target': { className, id, nodeName },
            })
        }

        last = current
    })
}

// Enable slowPageLoadTracking, monitorPageRefreshes and rageClickDetecion
// Detecting user frustration https://www.bugsnag.com/content/detecting-user-frustrations
slowPageLoadTracking()
monitorPageRefreshes()
rageClickDetecion()

export default bugsnagClient
